var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMaskito } from "@maskito/react";
import { TextField } from "@opala-ds/react";
import { cpfMask, digitsOnlyMask } from "../../../../utils/masks";
export default function TechnicalCPFAndRGField(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var index = _a.index, register = _a.register, errors = _a.errors;
    var cpfRef = useMaskito({ options: cpfMask });
    var rgRef = useMaskito({ options: digitsOnlyMask });
    return (_jsxs(_Fragment, { children: [_jsx(TextField, __assign({ label: "CPF" }, register("comissao_tecnica.".concat(index, ".cpf")), { helperText: (_e = (_d = (_c = (_b = errors.comissao_tecnica) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.cpf) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "", variant: ((_g = (_f = errors.comissao_tecnica) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.cpf) ? "critical" : "default", ref: function (node) {
                    cpfRef(node);
                    register("comissao_tecnica.".concat(index, ".cpf")).ref(node);
                } })), _jsx(TextField, __assign({ label: "RG" }, register("comissao_tecnica.".concat(index, ".rg")), { helperText: (_l = (_k = (_j = (_h = errors.comissao_tecnica) === null || _h === void 0 ? void 0 : _h[index]) === null || _j === void 0 ? void 0 : _j.rg) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : "", variant: ((_o = (_m = errors.comissao_tecnica) === null || _m === void 0 ? void 0 : _m[index]) === null || _o === void 0 ? void 0 : _o.rg) ? "critical" : "default", ref: function (node) {
                    rgRef(node);
                    register("comissao_tecnica.".concat(index, ".rg")).ref(node);
                } }))] }));
}
